// extracted by mini-css-extract-plugin
module.exports = {"wrap":"mention_wrap__Nramj","mention":"mention_mention__QeBdo"};